import { KG_NODE_STYLES } from './kg-constants'

interface KgLegendProps {
  visibleTypes: Set<string>
}

export function KgLegend({ visibleTypes }: KgLegendProps) {
  const types = Array.from(visibleTypes).sort()

  if (types.length === 0) return null

  return (
    <div className="flex flex-wrap gap-2 px-3 py-2 bg-gray-50 dark:bg-gray-800/50 rounded-lg border border-gray-200 dark:border-gray-700">
      {types.map(type => {
        const style = KG_NODE_STYLES[type]
        if (!style) return null
        return (
          <div key={type} className="flex items-center gap-1.5 text-xs text-gray-600 dark:text-gray-400">
            <span
              className="inline-block w-3 h-3 rounded-full flex-shrink-0"
              style={{ backgroundColor: style.color }}
            />
            <span>{formatLabel(type)}</span>
          </div>
        )
      })}
    </div>
  )
}

function formatLabel(label: string): string {
  return label.replace(/([A-Z])/g, ' $1').trim()
}
